<!-- Loader. -->
<section *ngIf="isLoading" style="text-align: center; margin: 40px 0">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>

<!-- DESKTOP =================================================================== -->

<!-- Header. -->
<div
	*ngIf="!isLoading && !isMobile"
	class="row user-card shadow clientsHeader"
	(window:resize)="onResize()"
>
	<!-- Always visible. -->
	<div class="row headerVisible">
		<div id="avMainTitle" class="centerContent">
			<h1>{{ 'PAGES.CLIENTS.ADDNEW' | translate }}</h1>
		</div>
	</div>
	<!-- /headerVisible. -->
</div>

<div
	*ngIf="!isLoading"
	class="row addNewContent"
	[ngClass]="{ formContent: !isMobile, shadow: !isMobile }"
>
	<section>
		<div>
			<!-- Side content. -->
			<div
				class="tabContentFrame tabSideContent"
				[ngClass]="{ formBlock: isMobile }"
			>
				<div class="frameTitle">
					{{ 'PAGES.CLIENTS.CLIENTDATA' | translate | uppercase }}
				</div>

				<div class="frameContent">
					<!-- First name. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.NAME' | translate | uppercase }}
						</p>
						<input
							type="text"
							class="form-control"
							[(ngModel)]="contactData.displayName"
						/>
					</div>

					<!-- Status. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.STATUS' | translate | uppercase }}
						</p>
						<select class="form-control" [(ngModel)]="contactData.status">
							<option
								*ngFor="let status of statusList | sortarray"
								value="{{ status.key }}"
								[selected]="status.key === contactData.status"
							>
								{{ status.text }}
							</option>
						</select>
					</div>

					<!-- Professional document. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.DOC' | translate | uppercase }}
						</p>
						<input
							type="text"
							class="form-control"
							[(ngModel)]="contactData.fiscalId"
						/>
					</div>

					<!-- iCD (International Classification of Diseases) -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.ICD' | translate | uppercase }}
						</p>
						<input
							type="text"
							class="form-control"
							[(ngModel)]="contactData.iCD"
						/>
					</div>

					<!-- Session Price. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.PRICEPERSESSION' | translate | uppercase }}
						</p>
						<div class="inpCurrencyGroup">
							<input
								class="form-control inpCurrencySymbol"
								[ngClass]="{ inpRight: userPref.Currency == 'EUR' }"
								placeholder="{{ userPref.CurrencySymbol }}"
								disabled="disabled"
							/>
							<input
								[(ngModel)]="sessionPrice"
								type="text"
								class="form-control inpCurrencyField"
								[ngClass]="{ inpRight: userPref.Currency == 'EUR' }"
								(focus)="valueGotFocus()"
								placeholder="0,00"
								value="{{ contactData.sessionPrice | number: '.2-2' }}"
								currencyMask
								aria-describedby="sizing-addon1"
							/>
						</div>
					</div>
				</div>
			</div>
			<!-- /tabSideContent. -->

			<!-- Main content. -->
			<div
				class="tabContentFrame tabMainContent"
				[ngClass]="{ formBlock: isMobile }"
			>
				<div class="frameTitle">
					{{ 'GENERAL.CONTACT' | translate | uppercase }}
				</div>

				<div class="frameContent borderLeft">
					<!-- E-Mail. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.EMAIL' | translate | uppercase }}
						</p>
						<input
							type="email"
							class="form-control"
							[(ngModel)]="contactData.email"
						/>
					</div>

					<!-- Phone. -->
					<div class="formContainer">
						<table class="table tabForm tabPhone">
							<tr>
								<td class="formFieldTitle">
									{{ 'GENERAL.PHONE' | translate | uppercase }}
								</td>
								<td class="formFieldTitle">
									{{ 'GENERAL.PHONEMOBILE' | translate | uppercase }}
								</td>
							</tr>
							<tr>
								<td style="padding-right: 10px">
									<input
										type="phone"
										class="form-control"
										[(ngModel)]="contactData.phoneFix"
									/>
								</td>
								<td>
									<input
										type="phone"
										class="form-control"
										[(ngModel)]="contactData.phoneMobile"
									/>
								</td>
							</tr>
						</table>
					</div>

					<!-- Address. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.ADDRESS' | translate | uppercase }}
						</p>
						<input
							type="text"
							class="form-control"
							[(ngModel)]="contactData.address"
							placeholder="{{ 'PLACEHOLDERS.ADDRESS' | translate }}"
						/>
						<table class="table tabForm tabAddress">
							<tr>
								<td>
									<input
										type="text"
										class="form-control"
										[(ngModel)]="contactData.postalCode"
										placeholder="{{ 'PLACEHOLDERS.POSTALCODE' | translate }}"
									/>
								</td>
								<td style="padding: 5px">
									<input
										type="text"
										class="form-control"
										[(ngModel)]="contactData.city"
										placeholder="{{ 'PLACEHOLDERS.CITY' | translate }}"
									/>
								</td>
								<td>
									<input
										type="text"
										class="form-control"
										[(ngModel)]="contactData.country"
										placeholder="{{ 'PLACEHOLDERS.COUNTRY' | translate }}"
									/>
								</td>
							</tr>
						</table>
					</div>

					<!-- Comments. -->
					<div class="formContainer">
						<p class="formFieldTitle">
							{{ 'GENERAL.COMMENTS' | translate | uppercase }}
						</p>
						<textarea
							class="form-control"
							style="resize: vertical"
							maxlength="255"
							rows="3"
							placeholder=""
							[(ngModel)]="contactData.notes"
						></textarea>
					</div>
				</div>
			</div>
			<!-- /tabMainContent. -->
		</div>

		<!-- Operation buttons. -->
		<div class="buttonsFrame">
			<!-- Cancel edit. -->
			<button
				type="button"
				class="btn btn-default btnCancel"
				(click)="cancel()"
			>
				<fa-icon icon="times-circle"></fa-icon>
				{{ 'OPERATIONS.CANCEL' | translate | uppercase }}
			</button>

			<!-- Save. -->
			<button type="button" class="btn btn-primary btnSave" (click)="save()">
				<fa-icon icon="save"></fa-icon>
				{{ 'OPERATIONS.SAVE' | translate | uppercase }}
			</button>
		</div>
	</section>
</div>
